export const fileUpload = async (http, file, fileLoading) => {
  fileLoading = true;
  const res = await http({
    method: "post",
    url: "index/upload",
    data: {
      file: file,
    },
  });
  fileLoading = false;
  
};

export const fileChange = async (file, files) => {
 
};

export const htmlDecodeByRegExp = (str) => {
  var temp = "";
  if (str.length == 0) return "";
  temp = str.replace(/&amp;/g, "&");
  temp = temp.replace(/&lt;/g, "<");
  temp = temp.replace(/&gt;/g, ">");
  temp = temp.replace(/&nbsp;/g, " ");
  temp = temp.replace(/&#39;/g, "'");
  temp = temp.replace(/&quot;/g, '"');
  temp = temp.replace(/↵/g, "");
  return temp;
};

// 一键复制功能
export const copyToClipboard = async (text) => {
  try {
    // 优先使用现代浏览器的 Clipboard API
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(text);
      return { success: true, message: '复制成功' };
    } else {
      // 降级方案：使用传统的 document.execCommand
      const textArea = document.createElement('textarea');
      textArea.value = text;
      textArea.style.position = 'fixed';
      textArea.style.left = '-999999px';
      textArea.style.top = '-999999px';
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      
      const successful = document.execCommand('copy');
      document.body.removeChild(textArea);
      
      if (successful) {
        return { success: true, message: '复制成功' };
      } else {
        throw new Error('复制失败');
      }
    }
  } catch (err) {
    console.error('复制失败:', err);
    return { success: false, message: '复制失败，请手动复制' };
  }
};
